import Common from './common/common';
import Form from './form/form';
import { NavigationComponents } from './navigation/navigation.components';
import { CardsComponents } from './cards/cards.components';
import { StatesComponents } from './states/states.components';
import { CallsComponents } from './calls/calls.components';
import { FilesComponents } from './files/files.components';

export const commonComponents = {
  ...Common.components,
  ...Form,
  ...NavigationComponents,
  ...CardsComponents,
  ...StatesComponents,
  ...CallsComponents,
  ...FilesComponents
};
